import { CursorProps } from 'react-arborist';

export const CustomCursor = ({ indent, left, top }: CursorProps) => {
  return (
    <div
      className="flex items-center z-1 absolute right-5 pointer-events-none"
      style={{
        top,
        left: left + indent,
      }}
    >
      <div className="w-1 h-1 rounded-full shadow-[0px_0px_0px_3px_#4b91e2]" />
      <div className="flex-1 h-0.5 bg-[#4b91e2] rounded-[1px]" />
    </div>
  );
};
